<div class="email-dialog">
  <h1 mat-dialog-title>Update and email RFQs</h1>
</div>
<div mat-dialog-content class="email-content">
  <div>The updated RFQs will be emailed to the vendors listed below. Kindly check that all information are accurate.</div>
  <div class="email-vendor">
    <div class="label">Vendor / Email:</div>
    <div>
      <div *ngFor="let vendor of vendorForm">{{vendor?.Name}} / {{vendor.OtherPersonEmail ?? vendor.EmailAddress}}</div>
    </div>
  </div>
</div>
<div class="btn-block" mat-dialog-actions>
  <app-button class="padBtn" name="Cancel" (click)="close()"></app-button>
  <app-button [disabled]="disabled" type="flat-button" class="padBtn actionBtn" name="Update and email RFQs" (click)="!disabled && updateAndSendRFQ()"></app-button>
</div>